import { IntegrationTypeEnum } from 'modules/global/typing/enums/integrations.enum';

export const getDefaultCurrencyIsoCode = dealer => (
  dealer?.config?.general?.country?.currencyIsoCode ??
  dealer?.country?.currencyIsoCode
);

/**
 * @param {import('modules/dealers/types').Dealer} dealer
 * @return {string}
 */
export const getDealerLanguage = dealer => (
  dealer?.config?.general?.customerDefaultLanguage ??
  dealer?.customerDefaultLanguage ?? dealer?.country?.code ?? dealer?.countryCode
);

export const extractExtensionFromAction = action => {
  let extension;
  if (action.meta) {
    extension = action.meta.extension;
  }
  if (!extension && action.params) {
    const { extensions = [] } = action.params;
    const [extensionParam] = extensions;
    extension = extensionParam;
  }
  return extension;
};

export const extractAutoSelectFromAction = action => {
  let autoSelect;
  if (action.meta) {
    autoSelect = action.meta.autoSelect;
  }
  return autoSelect;
};

/**
 * @param {import('modules/dealers/_types/types').DEALER} dealer
 * @returns {boolean}
 */
export const canPlanIntervention = dealer => dealer?.config?.integration?.integrations?.includes(IntegrationTypeEnum.SOFT_NRG) ?? false;

/**
 * @param {import('modules/dealers/_types/types').DEALER} dealer
 * @returns {number}
 */
export const getValueAddedTax = dealer => dealer?.config?.general?.valueAddedTax ?? dealer?.country?.valueAddedTax;

/**
 * @param {import('modules/dealers/_types/interfaces/config-self-service').AvailableTypes} availableTypes
 * @returns {boolean}
 */
export const hasSelfService = (availableTypes = {}) =>
  Object.values(availableTypes).some((origins = []) => origins.length > 0);

/**
 * @param {import('modules/dealers/_types/interfaces/config-self-service').AvailableTypes} availableTypes
 * @param {import('modules/selfServices/types').SelfServiceTypeEnum} type
 * @returns {boolean}
 */
export const hasSelfServiceType = (availableTypes, type) => availableTypes?.[type]?.length > 0;

/**
 * @param {import('modules/dealers/_types/interfaces/config-self-service').AvailableTypes} availableTypes
 * @param  {...import('modules/selfServices/types').SelfServiceOriginEnum} origins
 * @return boolean
 * @example - hasOrigins(config, SELF_SERVICE_ORIGIN.ON_SITE)
 */
export const hasSelfServiceOrigin = (availableTypes = {}, ...origins) =>
  Object.values(availableTypes).some(
    (selectedOrigins = []) => Array.isArray(selectedOrigins) && selectedOrigins.some(origin => origins.includes(origin))
  );

/**
 * @param {import('modules/dealers/_types/interfaces/config-self-service').AvailableTypes} availableTypes
 * @param {Record<import('modules/selfServices/types').SelfServiceTypeEnum, import('modules/selfServices/types').SelfServiceOriginEnum[]>} originType
 * @returns {boolean}
 */
export const hasSelfServiceTypesOrigins = (availableTypes = {}, originType = {}) => Object.entries(originType).some(([type, origins = []]) =>
  origins.some(origin => availableTypes[type]?.includes(origin)));

/**
 * @param {import('modules/dealers/_types/interfaces/config-self-service').AvailableTypes} availableTypes
 * @param {Record<import('modules/selfServices/types').SelfServiceTypeEnum, import('modules/selfServices/types').SelfServiceOriginEnum[]>} originType
 * @returns {boolean}
 */
export const hasSelfServiceTypesOriginsStrict = (availableTypes = {}, originType = {}) => Object.entries(originType).every(([type, origins = []]) =>
  origins.every(origin => availableTypes[type]?.includes(origin)));
